import { UploadOutlined } from '@ant-design/icons';
import { Form, Input, Modal, Upload } from 'antd';
import React, { useEffect, useState } from 'react';
import { TASelect } from '../../ta-select';
import { ButtonType, TAButton, TAInputNumber } from '../../widgets';
import constants from '../constants';
import { TADatePicker } from '../styles';
import currencies from '../../../constants/currencies';

export const JobOfferModalForm: React.FC<any> = ({ values, onCancel, onOk, visible, headerTitle }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState<boolean>(false);
	useEffect(() => {
		if (values) form.setFieldsValue(values);
	}, [values, form]);

	const onFormCancel = () => {
		onCancel && onCancel();
	};

	const onFinish = async values => {
		if (values.attachment) values.attachment = values.attachment.file;
		setLoading(true);
		if (onOk && (await onOk(values))) {
			form.resetFields();
			setLoading(false);
			return;
		}
		form.resetFields();
		setLoading(false);
		return;
	};

	return (
		<Modal
			title={headerTitle || 'Make an Offer'}
			visible={visible}
			onCancel={onFormCancel}
			onOk={form.submit}
			okText="Offer"
			// width="40%"
			okButtonProps={{ loading }}
			className="ta-modal"
		>
			<Form
				layout="horizontal"
				className="ta-form py-5"
				labelCol={{ xs: { span: 24 }, xl: { span: 8 } }}
				wrapperCol={{ xs: { span: 24 }, xl: { span: 16 } }}
				labelAlign="left"
				form={form}
				onFinish={onFinish}
			>
				<Form.Item
					label="Salary"
					name="salary"
					rules={[{ required: true, message: 'You must specify a salary.' }]}
				>
					<TAInputNumber
						formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
						parser={(value: any) => value.replace(/\s?(,*)\s?/g, '')}
						placeholder="e.g., 6000"
						step={100}
					/>
				</Form.Item>
				<Form.Item
					label="Currency"
					name="currency"
					rules={[{ required: true, message: 'You must specify a currency.' }]}
					initialValue={constants.Currencies.EGP}
				>
					<TASelect showSearch placeholder="currency">
						{Object.keys(currencies).map(currency => (
							<TASelect.Option key={currency} value={currency}>
								{currency}
							</TASelect.Option>
						))}
					</TASelect>
				</Form.Item>
				<Form.Item
					label="Job Type"
					name="jobType"
					initialValue={constants.JobTypes.FULL_TIME}
					rules={[{ required: true, message: 'You must specify a job type.' }]}
				>
					<TASelect showSearch placeholder="job type">
						{Object.values(constants.JobTypes)
							.filter(t => t !== constants.JobTypes.REMOTE)
							.map(type => (
								<TASelect.Option key={type} value={type}>
									{type}
								</TASelect.Option>
							))}
					</TASelect>
				</Form.Item>

				<Form.Item label="Starting Date" name="startingDate">
					<TADatePicker />
				</Form.Item>

				<Form.Item
					extra={
						<>
							<a
								href={
									'https://talentsarena-offer-attachment.s3.us-east-2.amazonaws.com/c1669380-6f69-4d86-bc81-7ec5ac40b8c7-Candidate%27s%20name%20Job%20offer.docx'
								}
							>
								Download
							</a>{' '}
							a job offer template ready.
						</>
					}
					label="Attachment"
					name="attachment"
				>
					<Upload beforeUpload={() => false} accept=".doc,.docx,.pdf,.text,.txt">
						<TAButton btntype={ButtonType.SECONDARY} className="d-flex align-items-center">
							<UploadOutlined />
							<span>Select File</span>
						</TAButton>
					</Upload>
				</Form.Item>

				<Form.Item label="Notes" name="notes">
					<Input.TextArea autoSize={{ minRows: 5, maxRows: 10 }} />
				</Form.Item>
			</Form>
		</Modal>
	);
};
